import { useCallback, useEffect, useState } from 'react'
import { useFetch, useRemoteCollection } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'
import { useFeatureEnabled } from 'core/feature/hooks'
import { useDuplicateQuestionnairePrompt } from './useDuplicateQuestionnairePrompt'
import { useRemoveQuestionnairePrompt } from './useRemoveQuestionnairePrompt'

export const useQuestionnairesCollection = () => {
  const [request, { loading, error }] = useFetch()
  const [questionnaires, operations] = useRemoteCollection()
  const organization = useCurrentOrg()
  const [initiallyLoaded, setInitiallyLoaded] = useState(false)
  const isQuestionnaireAsSurveyEnabled = useFeatureEnabled('QuestionnaireAsSurvey')

  const { syncCollection } = operations
  const getQuestionnaires = useCallback(async () => {
    const updatedQuestionnaires = await request({
      url: `/organizations/${organization.id}/${
        isQuestionnaireAsSurveyEnabled ? 'survey-questionnaires' : 'question-sets'
      }`,
    })

    syncCollection(updatedQuestionnaires)
    setInitiallyLoaded(true)
  }, [request, organization.id, isQuestionnaireAsSurveyEnabled, syncCollection])

  useEffect(() => {
    getQuestionnaires()
  }, [getQuestionnaires])

  const duplicateOne = useDuplicateQuestionnairePrompt(operations.eagerAdd)
  const deleteOne = useRemoveQuestionnairePrompt(operations.eagerRemove)

  return [
    {
      questionnaires,
      loading,
      error,
      initiallyLoaded,
    },
    {
      duplicateOne,
      deleteOne,
    },
  ]
}

export default useQuestionnairesCollection
